import { useCallback } from 'react';

const useDialogKeyboard = (dialogRef, onClose) => {
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      onClose();
      return;
    }

    if (event.key === 'Tab') {
      event.preventDefault();

      const focusableElements = [
        ...dialogRef.current.querySelectorAll(
          'button:not(.jsx-tab-buffer), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ),
      ].filter((element) => !element.disabled && element.tabIndex >= 0);

      const currentIndex = focusableElements.findIndex(
        (element) => document.activeElement === element,
      );
      let nextIndex = 0;

      if (event.shiftKey) {
        nextIndex = currentIndex - 1 < 0 ? focusableElements.length - 1 : currentIndex - 1;
      } else {
        nextIndex = (currentIndex + 1) % focusableElements.length;
      }

      focusableElements[nextIndex].focus();
    }
  }, [onClose, dialogRef]);

  return { handleKeyDown };
};

export default useDialogKeyboard;
